export const RequestStatus = {
  NEW: 1,
  APPROVED: 2,
  REJECTED: 3,
};

const REQUEST_STATUS_VARIANTS = {
  [RequestStatus.NEW]: "new",
  [RequestStatus.APPROVED]: "approved",
  [RequestStatus.REJECTED]: "rejected",
};

const REQUEST_STATUS_NAME_IDS = {
  yeni: RequestStatus.NEW,
  new: RequestStatus.NEW,
  noviy: RequestStatus.NEW,
  новый: RequestStatus.NEW,
  "ready to be sent": RequestStatus.NEW,
  "gonderilmeye hazir": RequestStatus.NEW,
  hazir: RequestStatus.NEW,
  tesdiq: RequestStatus.APPROVED,
  approved: RequestStatus.APPROVED,
  confirmation: RequestStatus.APPROVED,
  confirmed: RequestStatus.APPROVED,
  tesdiqlenib: RequestStatus.APPROVED,
  odobreno: RequestStatus.APPROVED,
  одобрено: RequestStatus.APPROVED,
  подтверждено: RequestStatus.APPROVED,
  imtina: RequestStatus.REJECTED,
  rejected: RequestStatus.REJECTED,
  refusal: RequestStatus.REJECTED,
  red: RequestStatus.REJECTED,
  otkloneno: RequestStatus.REJECTED,
  отклонено: RequestStatus.REJECTED,
};

/** Backend RequestStatus numeric IDs -> canonical UI status. */
const API_REQUEST_STATUS_IDS = {
  0: RequestStatus.NEW,
  1: RequestStatus.NEW,
  2: RequestStatus.APPROVED,
  3: RequestStatus.REJECTED,
};

function normalizeStatusName(value) {
  return String(value || "")
    .trim()
    .toLocaleLowerCase("az")
    .replace(/ı/g, "i")
    .replace(/ə/g, "e")
    .replace(/ş/g, "s")
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u");
}

function parseRequestStatusValue(value) {
  if (value == null || value === "") {
    return null;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  const asNumber = Number(value);
  if (!Number.isNaN(asNumber) && String(value).trim() !== "") {
    return asNumber;
  }

  const normalized = normalizeStatusName(value);
  return REQUEST_STATUS_NAME_IDS[normalized] ?? null;
}

function getRequestStatusFromIdFields(row) {
  if (!row) {
    return null;
  }

  const candidates = [
    row.requestStatus,
    row.RequestStatus,
    row.requestStatusId,
    row.RequestStatusId,
  ];

  for (const candidate of candidates) {
    const parsed = parseRequestStatusValue(candidate);
    if (parsed != null) {
      return parsed;
    }
  }

  return null;
}

export function getRequestStatus(row) {
  if (!row) {
    return null;
  }

  const rawId = getRequestStatusFromIdFields(row);
  if (rawId != null && Object.prototype.hasOwnProperty.call(API_REQUEST_STATUS_IDS, rawId)) {
    return API_REQUEST_STATUS_IDS[rawId];
  }

  const fromName = parseRequestStatusValue(row.requestStatusName);
  if (fromName != null) {
    return fromName;
  }

  return RequestStatus.NEW;
}

export function isRequestStatusNew(status) {
  return status === RequestStatus.NEW;
}

export function isRequestStatusApproved(status) {
  return status === RequestStatus.APPROVED;
}

export function isRequestStatusRejected(status) {
  return status === RequestStatus.REJECTED;
}

export function isRequestStatusPending(status) {
  return status === RequestStatus.NEW;
}

export function isRequestStatusFinal(status) {
  return status === RequestStatus.APPROVED || status === RequestStatus.REJECTED;
}

export function canDeleteRequest(row) {
  return isRequestStatusNew(getRequestStatus(row));
}

export function getRequestStatusVariant(status) {
  return REQUEST_STATUS_VARIANTS[status] ?? "unknown";
}
